// src/hooks/useQueueStatus.ts

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'; //-tech-debt-react-query;
import { fetchItems, postItem } from '../support/queries';

export interface QueueInfo {
  name: string;
  messages: number;
  consumers: number;
  error?: string;
}

export interface QueueStatusResponse {
  queues: QueueInfo[];
  timestamp: string;
}

export const useQueueStatus = () => {
  const queryClient = useQueryClient();

  const query = useQuery<QueueStatusResponse>({
    queryKey: ['queue-status'],
    queryFn: () => fetchItems('queue/status/'),
    ...{
        refetchInterval: 30000, // Changed from 5s to 30s
        staleTime: 20000,       // Consider data fresh for 20s
        retry: 3,
      },
  });

  // Purge queue mutation
  const purgeMutation = useMutation({
    mutationFn: () => postItem('queue/purge/', {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['queue-status'] });
    },
    onError: (error: any) => {
      console.error('Failed to purge queue:', error);
    },
  });

  return {
    status: query.data,
    loading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
    purgeQueue: purgeMutation.mutateAsync,
    isPurging: purgeMutation.isPending,
    purgeError: purgeMutation.error,
  };
};